import { partnerCriteriaSchema, type PartnerCriteria } from '@houzy/schemas/partner-cockpit/company';
import { queryOptions, useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { apiRequest } from '../../../lib/api';
import { partnerCockpitApiPath } from '../../../lib/config';
import { STALE_TIME_MS } from '../../../lib/queryClient';

const PARTNER_CRITERIA_PATH = 'company/criteria';

export async function fetchPartnerCriteria(signal?: AbortSignal): Promise<PartnerCriteria> {
    return apiRequest(partnerCockpitApiPath(PARTNER_CRITERIA_PATH), { signal, responseSchema: partnerCriteriaSchema });
}

export const partnerCriteriaQueryKey = ['settings', 'partnerCriteria'] as const;

export const partnerCriteriaQueryOptions = queryOptions({
    queryKey: partnerCriteriaQueryKey,
    queryFn: ({ signal }) => fetchPartnerCriteria(signal),
    staleTime: STALE_TIME_MS,
});

export function useSavePartnerCriteria(): UseMutationResult<void, Error, PartnerCriteria> {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['settings', 'save', 'partnerCriteria'],
        mutationFn: (criteria) =>
            apiRequest(partnerCockpitApiPath(PARTNER_CRITERIA_PATH), { method: 'PUT', body: criteria }),
        onSuccess: (_, criteria) => {
            queryClient.setQueryData<PartnerCriteria>(partnerCriteriaQueryKey, criteria);
        },
    });
}
